import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelToken = null;

class NotificationTypeService {
  getNotificationTypes() {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.get(`${Config.api.notification.url}notification-types`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
}

const notificationTypeService = new NotificationTypeService();

export default notificationTypeService;
